import Page from '@/found/components/table_page/table_page.vue';
import Form from './form';

export default {
  extends: Page,
  data() {
    return {
      formConfig: {},
      configs: {
        formConfig: {},
      },
      modalConfig: {},
    };
  },
  components: { Form },
  created() {
    this.getConfigList('page_list');
  },
  methods: {
    /**
     * 列表点击事件
     * @param {object} val 点击对象绑定数据
     * @param {object} row 点击列表行数据
     */
    modalClick({
      val,
      row,
    }) {
      const {
        code,
        name,
      } = val;
      this.formName = 'Form';
      if (code === 'add') {
        this.modalConfig.title = name;
        this.formConfig = {
          code,
        };
        this.openFull();
      }
      if (code === 'edit' || code === 'view') {
        this.modalConfig.title = code === 'edit' ? '编辑' : '查看';
        this.formConfig = {
          code,
          row,
        };
        this.openFull();
      }
      if (val.code === 'del') {
        if (this.selection.length === 0) {
          return this.$message.info('请至少选择一条数据');
        }
        const data = {
          params: { ids: this.selection.join(',') },
          url: val.apiUrl,
          title: val.ask,
          requestType: 'delete',
          msg: val.name,
        };
        this.messageBox(data);
      }
    },
  },
};
